import { createContext, FunctionComponent, useContext } from 'react';
import {
    SearchCriteriaStore,
    useSearchCriteriaStore,
} from './useSearchCriteriaStore';
import { UIStoreNS, useUIStore } from './useUIStore';
import useUserStore, { UserStoreNS } from './useUserStore';
import useSocketStore, { SocketStore } from './useSocketStore';

type Props = {
    children: JSX.Element;
};

type Stores = {
    SearchCriteriaStore: SearchCriteriaStore;
    SocketStore: SocketStore;
    UIStore: UIStoreNS.Store;
    UserStore: UserStoreNS.Store;
};

export const RootStoreContext = createContext({} as Stores);

const RootStore: FunctionComponent<Props> = ({ children }) => {
    const stores = {
        SearchCriteriaStore: useSearchCriteriaStore(),
        UIStore: useUIStore(),
        UserStore: useUserStore(),
        SocketStore: useSocketStore(),
    };

    return (
        <RootStoreContext.Provider value={stores}>
            {children}
        </RootStoreContext.Provider>
    );
};

export const useRootStoreContext = () => {
    return useContext(RootStoreContext);
};

export default RootStore;
